import { render, staticRenderFns } from "./product-setting.vue?vue&type=template&id=36c141d4&"
import script from "./product-setting.vue?vue&type=script&lang=js&"
export * from "./product-setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports